import React from 'react';

const platformRoles = {
  admin: 'ADMIN',
  manager: 'MANAGER',
  user: 'USER',

};                  

function PlatformRolesDropdown({ selectedValue, onPlatformRolesChange }) {
  return (
    <div className="select mt-1">
      <p className="mb-1">User Role</p>
      <select
        className="select-control bg-transparent"
        onChange={(e) =>
          onPlatformRolesChange({
            target: { name: 'role', value: e.target.value },
          })
        }
        name={'role'}
      >
        <option disabled={true} value="" selected={selectedValue === ''}>
          Select User Role
        </option>
        {Object.keys(platformRoles).map((item) => (
          <option
            key={platformRoles[item]}
            selected={selectedValue === platformRoles[item]}
            value={platformRoles[item]}
          >
            {platformRoles[item].toLowerCase().replace(/^\w/, (c) => c.toUpperCase())}
          </option>
        ))}
      </select>
    </div>
  );
}

export default PlatformRolesDropdown;
